export { default } from './CompanyContent';
